import { Component, OnInit, ViewChild } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginator } from "@angular/material/paginator"
import { MatSort } from "@angular/material/sort"
import { MatTableDataSource } from "@angular/material/table"
import { ActivatedRoute, Router } from "@angular/router"
import { AuthenticationService } from '../../../../access/shared/authentication/authentication.service'
import { LectureCab } from "../../shared/lecture-cab"
import { LectureCabService } from "../../shared/lecture-cab.service"
import { LectureDialogComponent } from './lecture-dialog/lecture-dialog.component'

@Component({
  selector: 'app-lecture-check',
  templateUrl: './lecture-check.component.html',
  styleUrls: ['./lecture-check.component.scss']
})
export class LectureCheckComponent implements OnInit {
  lecture
  lectureEtapes
  dataSource: MatTableDataSource<LectureCab> = new MatTableDataSource<LectureCab>()
  // Colonnes
  columns = [
    { id: 'client', libelle: 'Sous-compte' },
    { id: 'dateLecture', libelle: 'Date lecture' },
    { id: 'type', libelle: 'Etape' },
    { id: 'cabLu', libelle: 'ID Vts lus' },
    { id: 'cabOk', libelle: 'ID Vts enregistrés' },
    { id: 'cabKO', libelle: 'ID Vts KO' }
  ]
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
  @ViewChild(MatSort, { static: true }) sort: MatSort
  displayedColumns: Array<string> = ['client', 'dateLecture', 'type', 'cabLu', 'cabOk', 'cabKO', 'voirPlus']

  constructor(private router: Router,
    private route: ActivatedRoute,
    private lectureCabService: LectureCabService,
    private dialog: MatDialog,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    if (!this.lectureCabService.lecture) {
      this.router.navigate(['..'], { relativeTo: this.route })
    } else {
      let data = []
      this.lectureCabService.lecture.forEach(element => {
        if (data.length == 0 ||
          !data.find(item => item.client == element.client && item.dateLecture.includes(element.dateLecture) && item.type == element.type)) {
          data.push({
            client: element.client,
            dateLecture: element.dateHeureLecture,
            type: element.type,
            cabLu: 0,
            cabOk: 0,
            cabKO: 0
          })
        }
        let index = data.findIndex(item => item.client == element.client && item.dateLecture.includes(element.dateLecture) && item.type == element.type)
        data[index].cabLu += 1
        if (element.cabOk) {
          data[index].cabOk += 1
        } else {
          data[index].cabKO += 1
        }
      })

      data.sort((a, b) => {
        if (a.client < b.client) {
          return -1
        } else {
          return 1
        }
      })

      this.dataSource.data = data
      this.dataSource.paginator = this.paginator
      this.dataSource.sort = this.sort
    }
  }

  showCAB(row) {
    let cabsKO = this.lectureCabService.lecture.filter(item => !item.cabOk && item.client == row.client && item.dateHeureLecture == row.dateLecture && item.type == row.type)
    if (cabsKO.length > 0) {
      this.dialog.open(LectureDialogComponent, {
        data: { cabList: cabsKO }
      })
    }
  }
}
